import GsTreeNode from "./gs-tree-node.vue"
const component = {
  install: (Vue) => {
    Vue.component('GsTreeNode', GsTreeNode)
  }
}
export default component
